import { ActivityToMapType } from 'app/constants/configuration/activityToMapType'

export const getActivityToMapTypeName = (
  activityToMapType: ActivityToMapType,
  translate: (string) => string,
): string => {
  const text: string = ActivityToMapType[activityToMapType]
  return translate(`activityToMapType.${text}`)
}
